<template>
    <el-row :gutter="20">
        <el-col :span="8" :offset="8">
    <div class="sidebar-right user-select theme-gray">
        <div class="padding-1"
             @keyup.enter="logMeIn">
            <el-form label-position="top"
                     label-width="10px">
            <!--    <google-login-button size="mini"></google-login-button> 

                <div class="align-center margin-top-bottom-1">
                    <strong>Or</strong>
                </div>
                -->

                <div class="margin-bottom-half">
                    <el-input placeholder="Username or email address..."
                              name="username"
                              v-model="login.username"
                              required
                              size="mini"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"></el-input>
                </div>

                <div class="margin-bottom-half">
                    <el-input placeholder="Password..."
                              name="password"
                              v-model="login.password"
                              required
                              size="mini"
                              type="password"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"></el-input>
                </div>

                <div class="margin-bottom-half">
                    <el-alert v-for="e in login.errors.username"
                              :title="e"
                              type="error"
                              show-icon
                              :closable="false"
                              :key="e"></el-alert>

                    <el-alert v-for="e in login.errors.email"
                              :title="e"
                              type="error"
                              show-icon
                              :closable="false"
                              :key="e"></el-alert>

                    <el-alert v-for="e in login.errors.password"
                              :title="e"
                              type="error"
                              show-icon
                              :closable="false"
                              :key="e"></el-alert>
                </div>

                <div class="margin-bottom-1">
                    <el-checkbox v-model="login.remember"
                                 size="mini">
                        Remember me
                    </el-checkbox>
                </div>

                <div class="flex-space">
                    <el-button round size="mini"
                               @click="logMeIn"
                               :loading="login.loading"
                               :disabled="!login.username.trim() || !login.password.trim()"
                               type="success">
                        Login
                    </el-button>

                    <a class="el-button el-button--text el-button--mini"
                       href="/password/reset"
                    >
                        Forgotten password
                    </a>
                </div>
            </el-form>
        </div>

        <hr class="thik-light-hr">

        <div class="sidebar-offer-wrapper bounceIn animated">
            <h3>New to Humtog?</h3>

            <p>
                Join now and gain the oppurtunity to be one of the founding members!
            </p>

            <!--<el-button round type="primary"-->
            <!--size="mini"-->
            <!--@click="Store.modals.authintication.show = true"-->
            <!--class="full-width">-->
            <!--Sign up-->
            <!--</el-button>-->
            <el-button round type="primary"
                       size="mini"
                       @click="humtog_sighup()"
                       class="full-width">
                Sign up
            </el-button>
        </div>

        <hr class="thik-light-hr">

        <ul class="sidebar-copyright">
            <li>&copy; 2019 Humtog</li>
            <li>
                <router-link to="/about">About</router-link>
            </li>
         
            <li>
                <router-link to="/tos">Terms</router-link>
            </li>
            <li>
                <router-link to="/privacy-policy">Privacy Policy</router-link>
            </li>

        </ul>
    </div>
        </el-col>
    </el-row>
</template>

<script>
    import Helpers from '../../mixins/Helpers';
    import GoogleLoginButton from '../../components/GoogleLoginButton';

    export default {
        mixins: [Helpers],

        components: { GoogleLoginButton },

        data() {
            return {
                login: {
                    username: '',
                    password: '',
                    remember: true,
                    loading: false,
                    errors: []
                }
            };
        },
        created(){
            if(this.isLoggedIn){
                // alert('ues');
                this.$router.push('/');
            }
        },

        methods: {
            humtog_sighup(){
                this.$router.push('signup');
            },
            logMeIn() {
                this.login.loading = true;
                this.login.errors = [];

                axios
                    .post('/login', {
                        username: this.login.username,
                        password: this.login.password,
                        remember: this.login.remember
                    })
                    .then((response) => {
                        this.login.loading = false;
                        Vue.clearLS();
                        location.reload();
                    })
                    .catch((error) => {
                        this.login.errors = error.response.data.errors;
                        this.login.loading = false;
                    });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/Login.vue